import { isPlatformBrowser, Location, NgClass, NgFor, NgIf, NgOptimizedImage, NgStyle } from "@angular/common";
import { afterNextRender, AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Inject, Input, makeStateKey, OnDestroy, OnInit, Output, PLATFORM_ID, QueryList, Renderer2, signal, TransferState, ViewChild, ViewChildren } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterModule } from "@angular/router";
import { KebabCasePipe } from "@src/app/pipes/kebab-case.pipe";
import { ConfigService } from "@src/app/servicios/config/config.service";
import { PlatformService } from "@src/app/servicios/platform/platform.service";
import { PublicidadService } from "@src/app/servicios/publicidad/publicidad.service";
import { ReelsService } from "@src/app/servicios/reels.service";
import { SidenavService } from "@src/app/servicios/sidenav/sidenav.service";
import { environment } from "@src/environments/environment";
import { CookieService } from "ngx-cookie-service";
import { debounceTime, filter, first, firstValueFrom, Subscription } from "rxjs";
import { FooterService } from "@src/app/servicios/footer.service";
import { DeviceService } from "@src/app/servicios/device/device.service";
import { SeoService } from "@src/app/servicios/seo/seo.service";
import { GfkService } from "@src/app/servicios/gfk/gfk.service";
import { Orientation } from "@src/app/models/enums/orientation.enum";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { ComentariosService } from "@src/app/servicios/comentarios/comentarios.service";
import { ModalComentariosComponent } from "../modal-comentarios/modal-comentarios.component";

const TRANSFER_KEY = makeStateKey<any>("reelsTransferState");

@Component({
  selector: "app-reels",
  imports: [RouterModule, RouterLink, NgStyle, MatIconModule, NgClass, KebabCasePipe, NgOptimizedImage, NgIf, NgFor],
  providers: [ComentariosService],
  templateUrl: "./reels.component.html",
  styleUrl: "./reels.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReelsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() newsId: string;
  @Input() exitAnchorId: string;
  @Output() scrolledOut = new EventEmitter<void>();
  @ViewChild("container", { static: false }) container: ElementRef;
  @ViewChildren("noticiaElem") articles: QueryList<ElementRef>;
  arraLikesComents = signal(new Map<number, any>());
  noticiasFijadas = signal([]);
  likesNoticias = signal([]);
  ads = signal([]);
  isHorizontal = signal(undefined);
  constantesGlobales;
  entradillaVisible = false;
  rrssVisible = false;
  rrssVisibleHor: boolean[] = [];

  userLogin: any;
  likesComents = signal([]);
  scrollSub: Subscription;
  portadaReels: boolean = false;
  removedTemp;
  navigationSub: Subscription;
  reelsConfigNavigation: boolean = false;
  reelsConfigPubli: boolean = false;
  private isInitialized = false;
  orientationSub: Subscription;

  numLikes = signal(0);
  numComents = signal(0);
  likesUser: boolean;
  isIOS = false;
  newRoot;
  noticiaClass = ".noticia";
  animaciones = ["zoomInOut", "zoomOutIn"];
  private observer: IntersectionObserver;
  noticiasVistas: Set<number> = new Set();

  miniSrc: string;
  miniSrcDefault: string;

  oldCustomUrl: string;
  private isFirstReel: boolean;
  private isScrolling = false; // Flag to prevent overlapping scroll attempts

  constructor(
    private comentariosService: ComentariosService,
    private readonly renderer: Renderer2,
    private readonly sidenav: SidenavService,
    private readonly elementRef: ElementRef,
    public dialog: MatDialog,
    private readonly cookieService: CookieService,
    private readonly platformService: PlatformService,
    private readonly configService: ConfigService,
    private readonly transferState: TransferState,
    private readonly location: Location,
    private readonly activatedRoute: ActivatedRoute,
    private readonly kebabPipe: KebabCasePipe,
    private readonly adsService: PublicidadService,
    private readonly reelsService: ReelsService,
    private readonly footerService: FooterService,
    private readonly deviceService: DeviceService,
    private readonly seoService: SeoService,
    private readonly router: Router,
    private readonly gfkService: GfkService,
    @Inject(PLATFORM_ID) private readonly platformId,
    private readonly gaService: GoogleAnalyticsService,
  ) {
    this.footerService.setShowFooter(false);
    this.constantesGlobales = this.configService.getConstantesGlobales();
    const configPrensa = configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((config) => {
        if (!config) return;
        if (config.general["app-home"].portada_reels_movil === "true") {
          this.portadaReels = true;
        }
        if (config.general["app-home-reels"].reel_navigation === "true") {
          this.reelsConfigNavigation = true;
        }
        if (config.general["app-home-reels"].publi_reels === "true") {
          this.reelsConfigPubli = true;
        }
      });
    }

    this.elementRef.nativeElement.style.setProperty("--background-color", this.constantesGlobales.color);

    if (this.deviceService.getOS().name === "iOS") {
      this.isIOS = true;
    }

    this.gfkImpression();

    afterNextRender(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.setupInitialRendering();
      }
    });
  }

  initRouteHandle() {
    if (this.router?.events) {
      this.navigationSub = this.router.events
        .pipe(
          filter((evt) => evt instanceof NavigationEnd),
          debounceTime(100), // Prevent rapid-fire events
        )
        .subscribe(() => {
          let tmpNewsArray = this.noticiasFijadas();
          const id = this.activatedRoute.snapshot.params["id"];
          if (this.removedTemp) {
            tmpNewsArray = [...tmpNewsArray.slice(0, this.removedTemp.index), this.removedTemp.news, ...tmpNewsArray.slice(this.removedTemp.index)];
            this.removedTemp = null;
          }
          const index = tmpNewsArray?.findIndex((noticia) => noticia.idVideo === id);
          if (index !== -1) {
            const [deletedNews] = tmpNewsArray.splice(index, 1);
            if (deletedNews) this.removedTemp = { index, news: deletedNews };
          }
          this.noticiasFijadas.set(tmpNewsArray);
          this.scrollToPreviousReel();
        });
    }
  }

  ngOnInit(): void {
    this.orientationSub = this.reelsService.orientation$.subscribe((value) => {
      if (value != Orientation.Clasico) {
        this.isHorizontal.set(value == Orientation.Horizontal ? true : false);
      }
    });

    this.sidenav.setIsScrolled(false);
    this.sidenav.setLogoVisibility(false);
    this.isFirstReel = true;

    this.initRouteHandle();

    this.getNoticiasReels(this.activatedRoute.snapshot.params["id"] ?? null).then(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.scrollToPreviousReel();
      }
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.container?.nativeElement) {
      this.handleOrientation();
      this.isInitialized = true;
    }

    // Ensure articles updates are tracked
    this.articles?.changes.pipe(debounceTime(100)).subscribe(() => {
      if (this.isInitialized && isPlatformBrowser(this.platformId)) {
        this.scrollToPreviousReel();
      }
    });
  }

  private setupInitialRendering(): void {
    if (this.articles?.length > 0 && this.container?.nativeElement) {
      this.handleOrientation();
      this.isInitialized = true;
      this.scrollToPreviousReel();
    } else {
      this.articles?.changes.pipe(first()).subscribe(() => {
        this.handleOrientation();
        this.isInitialized = true;
        this.scrollToPreviousReel();
      });
    }
  }

  private handleOrientation(): void {
    if (this.isHorizontal() && this.container) {
      this.setupObserver(".container-horizontal", ".noticia-horizontal");
    } else if (this.isHorizontal() !== undefined && !this.isHorizontal() && this.container) {
      this.setupObserver(".container", ".noticia");
    }
  }

  private setupObserver(containerClass: string, noticiaClass: string): void {
    setTimeout(() => {
      try {
        this.newRoot = this.renderer.selectRootElement(containerClass, true);
        this.noticiaClass = noticiaClass;
        this.restartObserver(this.newRoot, this.noticiaClass);
      } catch (error) {
        console.error(`No se pudo seleccionar el contenedor: ${containerClass}`, error);
      }
    }, 1000);
  }

  initObserver(newRoot: HTMLElement, noticiaClass: string) {
    if (this.observer) this.observer.disconnect();
    this.observer = new IntersectionObserver(
      (noticias) => {
        if (!this.isHorizontal()) {
          setTimeout(() => {
            this.rrssVisible = false;
            this.entradillaVisible = false;
          }, 100);
        }

        noticias.forEach((noticia) => {
          if (noticia.isIntersecting && noticia.intersectionRatio >= 0.5) {
            const noticiaId = parseInt(noticia.target.id.split("-")[1], 10);
            if (!this.noticiasVistas.has(noticiaId)) {
              this.noticiasVistas.add(noticiaId);
              this.getLikesComentsNoticia(noticiaId.toString());
              if (this.reelsConfigNavigation) {
                const index = this.noticiasFijadas()?.findIndex((item) => item.idVideo === noticiaId.toString());
                if (index !== -1) {
                  this.setReelUrl(index);
                  this.guardarIdNoticia(noticiaId);
                } else {
                  console.warn(`No se encontró el idVideo ${noticiaId} en noticiasFijadas`);
                }
              }
            }
          }
        });
      },
      {
        root: newRoot,
        threshold: 0.5,
        rootMargin: "0px -1% 0px -1%",
      },
    );

    const items = document.querySelectorAll(`${noticiaClass}`);
    items.forEach((item) => this.observer.observe(item));
  }

  restartObserver(newRoot, noticiaClass) {
    this.initObserver(newRoot, noticiaClass);
  }

  scrollToPreviousReel() {
    if (!isPlatformBrowser(this.platformId) || !this.container?.nativeElement || this.isScrolling) return;

    const reelIdSaved = parseInt(sessionStorage.getItem("reelIdSaved"), 10);
    if (!reelIdSaved) return;

    this.isScrolling = true;

    const attemptScroll = () => {
      const targetArticle = this.articles?.find((article) => {
        const id = parseInt(article.nativeElement.id.split("-")[1], 10);
        return id === reelIdSaved;
      });
      console.log("targetArticle", targetArticle);

      if (targetArticle) {
        const scrollOptions: ScrollToOptions = {
          behavior: "smooth",
        };
        if (this.isHorizontal()) {
          scrollOptions.left = targetArticle.nativeElement.offsetLeft;
        } else {
          scrollOptions.top = targetArticle.nativeElement.offsetTop;
        }
        this.container.nativeElement.scroll(scrollOptions);
        sessionStorage.removeItem("reelIdSaved");
        setTimeout(() => (this.isScrolling = false), 500); // Reset after scroll animation
      } else {
        console.error(`No se encontró la noticia con ID #noticia-${reelIdSaved}`);
        this.isScrolling = false;
      }
    };

    if (this.articles?.length > 0) {
      attemptScroll();
    } else {
      this.articles?.changes.pipe(first()).subscribe(() => {
        attemptScroll();
      });
    }
  }

  private async getNoticiasReels(newsId): Promise<void> {
    if (!this.platformService.isBrowser()) {
      await this.fetchNewsAndStoreKey(newsId);
    } else {
      if (this.transferState.hasKey(TRANSFER_KEY)) {
        const news = this.transferState.get<any>(TRANSFER_KEY, null);
        this.transferState.remove(TRANSFER_KEY);
        this.setNews(news);
      } else {
        await this.fetchNewsAndStoreKey(null);
      }
    }
  }

  openComentariosDialog(idVideo): void {
    this.dialog.open(ModalComentariosComponent, {
      panelClass: "modal-comentarios",
      data: { idNoticia: idVideo },
      maxHeight: "80vh",
    });
  }

  private fetchNewsAndStoreKey(newsId): Promise<void> {
    return new Promise((resolve) => {
      const reelsNews = this.reelsService.getNoticiasReels(this.constantesGlobales.idAmbito, newsId, 1);
      if (reelsNews) {
        firstValueFrom(reelsNews).then((result) => {
          if (!result) return;
          let filtro = result.filter((obj) => obj !== null && obj !== undefined);
          this.rrssVisibleHor = new Array(result.length).fill(false);
          if (this.newsId) {
            filtro = filtro.filter((noticia) => noticia?.idVideo != this.newsId);
          }
          this.setNews(filtro);
          this.transferState.set(TRANSFER_KEY, filtro);
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  setNews(news) {
    this.noticiasFijadas.set(news);
    if (this.reelsConfigPubli) {
      this.getIspotAds();
    }
    this.setReelUrl(0);
    this.getLikesComentsNoticia(news[0].idVideo);
  }

  setReelUrl(index: number) {
    if (!this.reelsConfigNavigation) return;
    if (this.portadaReels) {
      if (index !== 0) {
        this.location.go(`/reels/${this.noticiasFijadas()[index].idVideo}/${this.kebabPipe.transform(this.noticiasFijadas()[index].tituloSeo)}`);
        this.gfkImpression();
      }
    } else {
      this.location.go(`/reels/${this.noticiasFijadas()[index].idVideo}/${this.kebabPipe.transform(this.noticiasFijadas()[index].tituloSeo)}`);
      this.gfkImpression();
    }
    const customUrl = `${this.constantesGlobales.siteDomain}/reels/${this.noticiasFijadas()[index].idVideo}/${this.kebabPipe.transform(this.noticiasFijadas()[index].tituloSeo)}`;
    if (customUrl !== this.oldCustomUrl) {
      this.gaService.pageView(customUrl);
      this.oldCustomUrl = customUrl;
    }

    this.seoService.updateMetaTags(this.noticiasFijadas()[index], customUrl);
  }

  trackById(index, item) {
    return item.idVideo;
  }

  private gfkImpression(): void {
    if (this.platformService.isBrowser()) {
      const customParams = {
        c1: this.stripProtocolAndSubdomain(this.constantesGlobales.siteDomain),
        c2: "reels",
      };
      this.gfkService.impression(customParams);
    }
  }

  stripProtocolAndSubdomain(url: string): string {
    const strippedUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
    return strippedUrl;
  }

  getIspotAds() {
    const publi = this.adsService.getPubli();
    if (publi) {
      publi.pipe(first()).subscribe(({ imagenes }) => {
        if (!imagenes) {
          return;
        }
        let ads: any[] = imagenes.filter((ad) => ad.nombre_grupo === "Movil - Reels");
        ads = ads.map((ad) => {
          return { type: "ads", imgUrl: ad.img, url: ad.enlace };
        });
        this.ads.set(ads);
      });
    }
  }

  /**
   * Obtiene los likes y comentarios de una noticia específica basada en su ID de video.
   *
   * Este método verifica si ya se han cargado los datos de likes y comentarios para el video
   * especificado. Si no se han cargado, realiza una solicitud al servicio correspondiente para
   * obtener los datos. Los datos obtenidos se procesan y se actualizan en las propiedades
   * correspondientes del componente.
   *
   * @param idVideo - El identificador único del video para el cual se desean obtener los likes y comentarios.
   *
   * - Si el usuario está autenticado (determinado por la existencia de una cookie), se utiliza
   *   el ID del usuario para obtener información personalizada sobre los likes y comentarios.
   * - Si el usuario no está autenticado, se obtienen los datos generales de likes y comentarios.
   *
   * El método actualiza las siguientes propiedades:
   * - `likesComents`: Mapa que contiene los datos de likes y comentarios.
   * - `numLikes`: Número total de likes del video.
   * - `numComents`: Número total de comentarios del video.
   * - `likesUser`: Indica si el usuario actual ha dado like al video.
   * - `arraLikesComents`: Mapa que almacena los datos de likes y comentarios por ID de video.
   *
   * Utiliza el servicio `noticiasService` para realizar las solicitudes y el servicio `cookieService`
   * para obtener la cookie del usuario autenticado.
   */
  getLikesComentsNoticia(idVideo): void {
    if (this.arraLikesComents()[idVideo]) return;
    let cookie = undefined;
    if (this.platformService.isBrowser()) {
      cookie = this.cookieService.get("userLogin" + environment.name);
    }

    if (cookie) {
      this.userLogin = JSON.parse(cookie);
      const likesComents = this.comentariosService.getLikesComents(idVideo, this.userLogin.id);
      if (likesComents) {
        firstValueFrom(likesComents).then((data) => {
          if (!data) return;
          this.likesComents.set(data);
          if (this.likesComents()["likes"] && this.likesComents()["likes"].length > 0) {
            this.numLikes.set(this.likesComents()["likes"][0].numLikes);
          } else {
            this.numLikes.set(0);
          }
          if (this.likesComents()["coments"] && this.likesComents()["coments"].length > 0) {
            this.numComents.set(this.likesComents()["coments"][0].numComents);
          } else {
            this.numComents.set(0);
          }
          if (this.likesComents()["likesUser"][0]) {
            this.likesUser = true;
          } else {
            this.likesUser = false;
          }
          this.arraLikesComents.update((map) => {
            map.set(idVideo, this.likesComents());
            return new Map(map);
          });
        });
      }
    } else {
      const likesComments = this.comentariosService.getLikesComents(idVideo);
      if (likesComments) {
        firstValueFrom(likesComments).then((data) => {
          if (!data) return;
          this.likesComents.set(data);
          if (this.likesComents()["likes"] && this.likesComents()["likes"].length > 0) {
            this.numLikes.set(this.likesComents()["likes"][0].numLikes);
          } else {
            this.numLikes.set(0);
          }
          if (this.likesComents()["coments"] && this.likesComents()["coments"].length > 0) {
            this.numComents.set(this.likesComents()["coments"][0].numComents);
          } else {
            this.numComents.set(0);
          }
          this.arraLikesComents.update((map) => {
            map.set(idVideo, this.likesComents());
            return new Map(map);
          });
        });
      }
    }
  }

  handleTouch() {
    if (!this.isHorizontal()) this.container?.nativeElement.scrollIntoView({ block: "start" });
  }

  onWindowScrollVertical(event): void {
    const exitStatus = this.handleReelsExit(event.target);
    if (exitStatus) return;

    setTimeout(() => {
      this.rrssVisible = false;
      this.entradillaVisible = false;
    }, 100);

    const noticias = this.elementRef.nativeElement.querySelectorAll(".noticia");

    const containerRect = this.container.nativeElement.getBoundingClientRect();
    const containerTop = containerRect.top;
    const containerBottom = containerRect.bottom;

    noticias.forEach((noticia, index) => {
      const noticiaRect = noticia.getBoundingClientRect();
      const noticiaTop = noticiaRect.top;
      const noticiaBottom = noticiaRect.bottom;

      if (noticiaTop >= containerTop && noticiaBottom <= containerBottom) {
        this.getLikesComentsNoticia(this.noticiasFijadas()[index].idVideo);
        if (this.reelsConfigNavigation) {
          this.setReelUrl(index);
        }
      }
    });
  }

  handleReelsExit(target): boolean {
    let element;
    try {
      if (this.exitAnchorId) {
        element = this.renderer.selectRootElement(`#${this.exitAnchorId}`, true);
      }
    } catch (error) {
      console.error(`No se pudo seleccionar el elemento con ID ${this.exitAnchorId}`, error);
      element = null;
    }
    if (!this.isHorizontal()) {
      if (this.isIOS && target.scrollTop < -20 && element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        return true;
      }
    } else {
      if (this.isIOS && target.scrollLeft < -20 && element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
    }
    return false;
  }

  guardarLike(idVideo): void {
    if (this.cookieService.get("userLogin" + environment.name)) {
      this.userLogin = JSON.parse(this.cookieService.get("userLogin" + environment.name));
      const sendLike = this.comentariosService.sendLike(this.userLogin.id, idVideo);
      if (sendLike) {
        firstValueFrom(sendLike).then((result) => {
          if (!result) return;
          if (result?.status === "1" || result?.status === "2") {
            delete this.arraLikesComents[idVideo];
            this.getLikesComentsNoticia(idVideo);
          }
        });
      }
    } else {
      this.sidenav.setIsScrolled(false);
    }
  }

  mostrarRRSS(): void {
    this.rrssVisible = !this.rrssVisible;
  }

  mostrarRRSSHor(index): void {
    this.rrssVisibleHor[index] = !this.rrssVisibleHor[index];
  }

  mostrarPopup(): void {
    if (this.platformService.isBrowser()) {
      const popup = document.getElementById("rrss");
      this.renderer.removeClass(popup, "closed");
      this.renderer.setStyle(popup, "display", "block");
      document.body.classList.add("no-scroll");
    }
  }

  cerrarPopup(): void {
    if (this.platformService.isBrowser()) {
      const popup = document.getElementById("rrss");
      const background = document.getElementById("popup-background");
      this.renderer.addClass(popup, "closed");
      setTimeout(() => {
        this.renderer.setStyle(popup, "display", "none");
        this.renderer.setStyle(background, "display", "none");
      }, 200);
      document.body.classList.remove("no-scroll");
    }
  }

  mostrarEntradilla(): void {
    this.entradillaVisible = !this.entradillaVisible;
  }

  updateMeta(index): void {
    const metaTags = {
      title: `Reels - ${this.noticiasFijadas()[index].titulo}`,
      description: `Reels - ${this.noticiasFijadas()[index].entradilla ?? ""}`,
      image: `${this.noticiasFijadas()[index].urlReels ?? this.noticiasFijadas()[index].urlReels ?? ""}`,
      url: `${this.constantesGlobales.siteDomain}/reels/${this.noticiasFijadas()[index].idVideo}/${this.kebabPipe.transform(this.noticiasFijadas()[index].tituloSeo)}`,
    };
    this.seoService.updateMetaTags(metaTags);
  }

  generateMiniSrc(src) {
    this.miniSrcDefault = src.replace(/caratula/i, "caratula_480");
    return this.miniSrcDefault;
  }

  errorImgMini(event, url) {
    if ((event.target.src = url)) return;
    event.target.src = url;
  }

  guardarIdNoticia(id: number) {
    sessionStorage.setItem("reelIdSaved", id.toString());
  }

  ngOnDestroy(): void {
    this.orientationSub?.unsubscribe();
    if (this.observer) {
      this.observer.disconnect();
    }
    this.navigationSub?.unsubscribe();
    this.scrollSub?.unsubscribe();
    if (this.platformService.isBrowser()) {
      this.footerService.setShowFooter(true);
      this.sidenav.setIsScrolled(false);
      this.sidenav.setLogoVisibility(false);
      document.body.classList.remove("no-scroll");
    }
  }
}
